import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const EmptyState = ({ hasSearchFilter }) => {
  const navigate = useNavigate();

  if (hasSearchFilter) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center shadow-elevation-sm">
        <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-muted/40 rounded-full mx-auto mb-4 md:mb-6">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2 md:mb-3">
          Nenhum modelo encontrado
        </h3>
        <p className="text-sm md:text-base text-muted-foreground font-body max-w-md mx-auto">
          Nenhum modelo corresponde à sua busca. Tente outro termo.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center shadow-elevation-sm">
      <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-muted/40 rounded-full mx-auto mb-4 md:mb-6">
        <Icon name="LayoutTemplate" size={32} className="text-muted-foreground" />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2 md:mb-3">
        Nenhum modelo cadastrado
      </h3>
      <p className="text-sm md:text-base text-muted-foreground font-body mb-6 md:mb-8 max-w-md mx-auto">
        Você ainda não criou nenhum modelo. Comece criando seu primeiro modelo personalizado.
      </p>
      <Button
        variant="default"
        size="lg"
        iconName="LayoutTemplate"
        iconPosition="left"
        onClick={() => navigate('/create-template')}
      >
        Criar Modelo
      </Button>
    </div>
  );
};

export default EmptyState;
